<form [formGroup]="addProductForm" (ngSubmit)="onSubmit()">
  <h2>Ajouter un produit</h2>
  <mat-form-field class="full-width-input">
    <input matInput placeholder="Nom du produit" formControlName="name">
  </mat-form-field>

  <button type="submit" mat-raised-button color="primary" (click)="onSubmit()">Valider</button>
  <button type="button" mat-button (click)="closeDialog()">Annuler</button>
</form>
